<template>
    <b-modal
        :id="id"
        v-model="openModal"
        title="Are you sure?"
        centered
        no-close-on-backdrop
        class="p-4"
        :hide-header-close="true"
    >
        <template #modal-title>
            <div class="p-2">
                {{ title }}
            </div>
        </template>
        <template class="modal-body p-0" />
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light pl-4 pr-4"
                    @click="$emit('agree')"
                >
                    Agree
                </button>
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light "
                    @click="$emit('disagree')"
                >
                    Disagree
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'confirm-delete-modal'
        },
        title: {
            type: String,
            required: false,
            default: 'Are you sure?'
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            openModal: false
        };
    },

    watch: {
        isOpen() {
            this.openModal = this.isOpen;
        }
    }
};
</script>
